import React, { useEffect, useMemo, useState } from "react";
import thumbPlaceholder from "../../assets/img/placeholder/video-placeholder-n.jpg";
import { prepareProjectScreener } from "../../utils/api/helpers/indee";
import { htmlToText } from "../../utils/Screeners/htmlToText";

const ScreenerListItem = ({
  projectName,
  scr,
  setLoaded,
  activeKey,
  activeScreener,
  setActiveScreener,
  multiSeason,
}) => {
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [episodeNumber, setEpisodeNumber] = useState(null);

  useEffect(() => {
    if (!scr) return;
    // Indee sends descriptions as HTML, and truncating has to count visible
    // characters rather than markup
    setDescription(truncate(htmlToText(scr.description)));
    setTitle(scr.name);
    setEpisodeNumber(scr.episode);
  }, [scr]);

  const truncate = (input) => {
    if (!input) return "";
    if (input.length > 130) return input.substring(0, 130) + "...";
    return input;
  };

  const scrScreenerKey = scr?.screening_details?.screener_key;
  const activeScreenerKey = activeScreener?.screening_details?.screener_key;

  const isActive = useMemo(() => {
    return (
      !!scrScreenerKey &&
      !!activeScreenerKey &&
      scrScreenerKey === activeScreenerKey
    );
  }, [scrScreenerKey, activeScreenerKey]);

  const prepareScreener = async () => {
    if (isActive) return;

    if (setLoaded) setLoaded(false);

    try {
      const result = await prepareProjectScreener(activeKey, scr.key);
      const newScreenerKey = result?.data?.screening_details?.screener_key;

      const nextScr = {
        ...scr,
        screening_details: {
          ...(scr.screening_details || {}),
          screener_key: newScreenerKey,
        },
      };

      setActiveScreener(nextScr);
    } catch (e) {
      console.log("prepareProjectScreener error", e);
      if (setLoaded) setLoaded(true);
    }
  };

  return (
    <div
      onClick={prepareScreener}
      className={
        "episodelist__item-container p-2 mb-2 d-flex " +
        (isActive ? "active" : "")
      }
      style={{ cursor: "pointer" }}
    >
      <div className={"col-3"}>
        <img
          src={scr?.poster ? scr.poster : thumbPlaceholder}
          alt={title || projectName}
          className={"episodelist__item-image"}
        />
      </div>

      <div className={"px-3"}>
        {multiSeason ? (
          <div
            style={{ fontSize: ".6rem", color: "#aaa" }}
            className={"my-2 text-uppercase fw-bold"}
          >
            Season {scr?.season}
          </div>
        ) : null}

        <div className={"episodelist__item-title"}>
          {episodeNumber ? `${episodeNumber} - ${title}` : projectName}
        </div>

        <div className={"episodelist__item-description"}>{description}</div>
      </div>
    </div>
  );
};

export default ScreenerListItem;
